// CALL AXIOS TO CONSUME WEB SERVICE
import axios from "axios"
import authHeader from "../authentification/AuthHeader";

//GET URL FROM .ENV ELEMENT
import { getUrl } from "../authentification/DotenvConfig"

/**
 * URL OF APP 
 * EXAMPLE : https://exemple/api/v1
 */
 const url = getUrl()

 /**
  * Get Compagnies
  * @returns 
  */
 export async function getCompanies() {
    try {
        const response = await axios.get(url + "companies", { headers: authHeader() }, {
            IsEssential: true
        });
        return response;
    } catch (error) {
        if (error.response) {
            // The request was made and the server responded with a status code
            return (error.response);
        } else if (error.request) {
            // The request was made but no response was received
            console.log(error.request);
        } else {
            // Something happened in setting up the request that triggered an Error
            console.log("Error", error.message);
        }
        console.log(error.config);
        return error;
    }
}



/**
 * GET SIGNATURE COMPAGNY
 * @param {*} id 
 * @returns 
 */
export async function getSignatureCompagny(id) {
    try {
        const response = await axios.get(url + "signatures/companies/"+id, { headers: authHeader(),'Access-Control-Allow-Origin': '*',
        ContentType: 'application/json' }, {
            IsEssential: true,
            withCredentials: true,  
       crossorigin: true,  
       mode: 'cors',     
        });
        return response;
    } catch (error) {
        if (error.response) {
            // The request was made and the server responded with a status code
            return (error.response);
        } else if (error.request) {
            // The request was made but no response was received
            console.log(error.request);
        } else {
            // Something happened in setting up the request that triggered an Error
            console.log("Error", error.message);
        }
        console.log(error.config);
        return error;
    }
}

